// extracted by mini-css-extract-plugin
export default {"primary":"style_primary__2PwDV","secondary":"style_secondary__9jyUW","third":"style_third__iw6Uj","fourth":"style_fourth__ki8Qk"};